var prop = {
	x 		: 0,
	xlen 	: 0,
	h 		:[],
	count	: 0,
	countX 	: 0,
	max		: 0,
	marginR : 10,
	firstRow: true,
	row: 0
}
var txtBlk = {};
var brs = [];//改行位置
var blks = [];
var rows = [];
var heights = [];
var m = {
	winW: 0,
	win: [0.0],
	innerW: 0,
	max: 0,
	init: function(){
		var $body = $("body");
		this.winW = window.innerWidth;
		$(".t").each(function(i){
			var txt = $(".t").eq(i).find("p").text();
			var len = txt.length;
			//console.log(txt, len)
			if(len >= 20){
				$(this).addClass("s0");
			}else if(len >= 10 && len < 20){
				$(this).addClass("s1");
			}else{
				$(this).addClass("s2");
			}
			//var ttt = i + $(this).find("p").text();
			var positionCls = ["top","btm"];
			//$(this).find("p").text(ttt);
			$(this).append('<span class="' + positionCls[Math.floor(Math.random()*2)] + '"></span>');
		});

		setTimeout(function(){
			m.resize();
			$("#block_mission .inner").addClass("active");
			setTimeout(function(){
				$("#block_mission .inner").addClass("nodelay");
			},2000);
		},200);

		var resizeFlag;
		var resizeTimer = null;
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			if(!isSP){
				m.resize();
				setTimeout(function(){
					m.resize();
				},500);
			}else{
				if (currentWidth != window.innerWidth) {
					m.resize();
				}else{

				}
			}
			this.winW = window.innnerWidth;
			resizeTimer = null;
		};

		$(window).off("resize").on("resize",function(){
			if(!$body.hasClass("resize")){
				$body.addClass("resize");
				
			}
			$("#block_mission").css("height", "");
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
	},
	resetProp: function(){
		prop.x = 0;
		prop.row = 0;
		prop.h = [];
		prop.count = 0;
		prop.max = $(".t").length;

		$(".t").removeClass(function(index, className) {
			return (className.match(/\bt\S+/g) || []).join(' ');
		});
		$(".t").removeClass(function(index, className) {
			return (className.match(/\br\S+/g) || []).join(' ');
		});
	},
	resize: function(){
		var $body = $("body");
		blks 	= [];
		brs 	= [];
		rows 	= [];
		heights = [];
		this.resetProp();

		this.win[0] = $(window).width();
		this.win[1] = $(window).height();
		this.innerW = $("#block_mission .inner").width() - 40;
		this.max = $(".t").length;
		
		var row = 0;
		var currentX = 0;
		var thisRow = [];

		$(".t").each(function(i){
			var $this = $(this);
			var _b = object(txtBlk);
			var w = Math.floor($(this).width());
			var h = Math.floor($(this).height());

			_b.size = [0,0];
			_b.size[0] = w;
			_b.size[1] = h;
			_b.pos = [0,0];
			_b.col = i;
			_b.around = [];
			
			$(this).attr({
				"data-w" : w,
				"data-h" : h
			})
			//positionX
			_b.pos[0] = currentX;
			_b.endX = _b.pos[0] + w + prop.marginR;
			//console.log(currentX, m.innerW)
			
			if(_b.pos[0] === 0){
				_b.firstCol = true;
			}else{
				_b.firstCol = false;
			}

			currentX += w + prop.marginR;
			thisRow.push(_b);
			$(this).addClass("r" + row);
			if(currentX >= m.innerW){
				_b.lastCol = true;
				rows[row] = thisRow;
				thisRow = [];
				_b.row = row;
				currentX = 0;
				row++;
			}else{
				_b.row = row;
				_b.lastCol = false;
			}
			
			//console.log(i,_b.pos[0], _b.firstCol, _b.lastCol, "row",_b.row)
			
			blks.push(_b);
		});
		var rowBoxCount = 0;
		var currentRow = 0;
		var maxRow = rows.length-1;
		for(var j = 0; j < blks.length; j++){
			var b = blks[j];
			if(currentRow != b.row){
				rowBoxCount = 0;
			}else{
				rowBoxCount++;
			}
			if(b.row === 0){
				//1行目
				b.pos[1] = 0;
				b.around[0] = -1;
				b.around[1] = -1;
				b.around[2] = -1;
				b.pos[1] = 0;
				b.around[3] = j-1;
				b.around[4] = j+1;
				//3,4,5,6,7
			}else{
				var baseCount = j - rowBoxCount;
				var count = j - baseCount;
				if(b.row >= maxRow){
					/*
					b.around[5] = -1;
					b.around[6] = -1;
					b.around[7] = -1;
					*/
					//0,1,2,3,4
				}
				//2行目以降
				if(b.firstCol){
					b.around[0] = -1;
					//2
					if(rows[b.row-1][count+1]){
						b.around[2] = rows[b.row-1][count + 1].col;
					}else{
						b.around[2] = rows[b.row-1][count].col;
					}
					b.around[3] = -1;
					b.around[4] = j+1;
					b.around[5] = -1;
				}else{
					//0
					b.around[0] = rows[b.row-1][count-1].col;
					b.around[3] = j-1;
					//5
					if(b.lastCol){
						var rowsLen = rows[b.row-1].length-1;
						b.around[2] = rows[b.row-1][rowsLen].col;
						b.around[4] = -1;
					}else{
						//2
						if(rows[b.row-1][count+1]){
							b.around[2] = rows[b.row-1][count + 1].col;
						}else{
							b.around[2] = rows[b.row-1][count].col;
						}
						b.around[4] = j+1;
					}
					
				}
				//1

				if(rows[b.row-1][count]){
					b.around[1] = rows[b.row-1][count].col;
				}else{
					b.around[1] = rows[b.row-1][count-1].col;
				}
				/*if(b.lastRow){
					
				}else{
					if(b.row != maxRow){
						b.around[5] = -1;
						b.around[6] = -1;
						b.around[7] = -1;
					}else{
					}
				}*/
				
			}
			//現在のブロックの左右２つ
			//console.log(j,b.around)
			//console.log("--");
			currentRow = b.row;
		}
		$(".t").each(function(k){
			$(this).css({
				"top" : blks[k].pos[1] + "px"
			});
		});
		//console.log("last:",blks[2].pos[0],blks[20].pos[0])
		//各ブロックの配置
		m.layout();

		//totalW = 0;
		

		/*var hArry = [];
		//ボックスの高さを決める
		var lastRow = ".r" + prop.row;
		$(lastRow).each(function(i){
			var h = Math.floor($(this).offset().top + $(this).height());
			hArry.push(h);
		});
		var innerH = Math.max.apply(null, hArry) - $("#content").offset().top + 40;
		//console.log(innerH,$("#content").offset().top)
		$("#block_mission").css({
			"height" : innerH + "px"
		});*/


		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},500)
	},
	layout: function(){
		for(var i = 0; i < blks.length; i++){
			var b = blks[i];
			var arry = [];
			var g0 = b.around[0],
				g1 = b.around[1],
				g2 = b.around[2],
				g3 = b.around[3],
				g4 = b.around[4];

			if(b.row === 0){
				//最初の行はそのまま
				b.endY = 0 + b.size[1];
				//console.log(i,b.endY)
			}else{
				var y = 0;
				if(b.around[0] != -1){
					var y0 = blks[g0].endY;
				}else{
					var y0 = 0;
				}
				if(b.around[2] != -1){
					var y2 = blks[g2].endY;
				}else{
					var y2 = 0;
				}
				var y1 = blks[g1].endY;
				var plusMargin = prop.marginR/10;
				//x
				if(b.around[0] != -1){
					var x0 		= blks[g0].pos[0];
					var x0end 	= blks[g0].endX + plusMargin;
				}else{
					var x0 		= 0;
					var x0end 	= 0;
				}
				if(b.around[2] != -1){
					var x2 		= blks[g2].pos[0];
					var x2end 	= blks[g2].endX + plusMargin;
				}else{
					var x2 		= 0;
					var x2end 	= 0;
				}
				var x1 		= blks[g1].pos[0];
				var x1end 	= blks[g1].endX + plusMargin;
				var thisX 	= b.pos[0];
				var thisXend = b.endX;
				
				var target = 0;

				if(thisXend < x0end){
					//おそらくありえない
				}else if(thisXend < x1end){
					if(thisX >= x1){
						arry = [y1];
					}else if(thisX >= x0){
						arry = [y0,y1];
					}
				}else if(thisXend < x2end){
					if(thisX >= x2){
						arry = [y2];
					}else if(thisX >= x1){
						arry = [y1,y2];
					}else if(thisX >= x0){
						if(thisXend <= x0end){
							arry = [y0];
						}else if(thisXend <= x1end){
							arry = [y0,y1];
						}else if(thisXend <= x2end){
							arry = [y0,y1,y2]
						}
					}
				}else if(thisXend > x2end){
					arry = [y2];
				}
				
				/*if(i === 54){
					console.log(target, thisX,thisXend,"/",x0,x0end,"/",x1,x1end,"/",x2,x2end);
					console.log(g0,g1,g2)
				}*/
				//console.log(i,arry);
				y = Math.max.apply(null, arry);
				b.pos[1] = y + prop.marginR;
				b.endY = b.pos[1] + b.size[1];
				//console.log(i,y,y0,y1,y2)
			}
		}

		$(".t").each(function(j){
			$(this).css({
				"top" : blks[j].pos[1] + "px",
				"right": blks[j].pos[0] + "px"
			});
			var _h = blks[j].pos[1] + $(this).height();
			heights.push(_h);
		});
		var innerH = Math.max.apply(null, heights) + 40;
		//console.log(innerH,$("#content").offset().top)
		$("#block_mission").css({
			"height" : innerH + "px"
		});
		FONTPLUS.reload();
	}
}
$(function(){
	m.init();
});